import { initializeApp, type FirebaseApp } from 'firebase/app';
import { connectFirestoreEmulator, getFirestore, type Firestore } from 'firebase/firestore';
import {
  getAuth,
  GoogleAuthProvider,
  browserLocalPersistence,
  connectAuthEmulator,
  setPersistence,
  type Auth,
} from 'firebase/auth';
import { getFunctions, type Functions } from 'firebase/functions';

// Firebase client config is intentionally public — security is enforced by
// Firestore Rules + Firebase Auth, not by keeping this key secret.
const config = {
  apiKey: 'AIzaSyD9tfKCwL9viaiQia1eMm-zU3XlGs3Q1hE',
  authDomain: 'mimikara-ee3f3.firebaseapp.com',
  projectId: 'mimikara-ee3f3',
  storageBucket: 'mimikara-ee3f3.appspot.com',
  messagingSenderId: '915413942671',
  appId: '1:915413942671:web:bbb5731a7e9fe986368bfa',
};

let appInstance: FirebaseApp | null = null;
let dbInstance: Firestore | null = null;
let authInstance: Auth | null = null;
let functionsInstance: Functions | null = null;

export function getFirebaseApp(): FirebaseApp {
  if (!appInstance) {
    appInstance = initializeApp(config);
  }
  return appInstance;
}

export function getDb(): Firestore {
  if (!dbInstance) {
    dbInstance = getFirestore(getFirebaseApp());
    if (import.meta.env.VITE_USE_EMULATOR === '1') {
      connectFirestoreEmulator(dbInstance, '127.0.0.1', Number(import.meta.env.VITE_FIRESTORE_EMULATOR_PORT ?? 8080));
    }
  }
  return dbInstance;
}

export function getAuthInstance(): Auth {
  if (!authInstance) {
    authInstance = getAuth(getFirebaseApp());
    if (import.meta.env.VITE_USE_EMULATOR === '1') {
      connectAuthEmulator(authInstance, 'http://127.0.0.1:9099', { disableWarnings: true });
    }
    setPersistence(authInstance, browserLocalPersistence).catch(() => {
      // best-effort; default fallback applies
    });
  }
  return authInstance;
}

export function getFirebaseFunctions(region = 'asia-southeast1'): Functions {
  if (!functionsInstance) {
    functionsInstance = getFunctions(getFirebaseApp(), region);
  }
  return functionsInstance;
}

export const googleProvider = new GoogleAuthProvider();

const STORAGE_BUCKET = 'mimikara-ee3f3.appspot.com';

export function audioPublicUrl(audioPath: string): string {
  const encoded = audioPath.split('/').map(encodeURIComponent).join('/');
  return `https://storage.googleapis.com/${STORAGE_BUCKET}/${encoded}`;
}
